exports = module.exports = require("../node_modules/.registry.npmjs.org/css-loader/0.25.0/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "svg {\n    -webkit-user-select: none; /* Chrome all / Safari all */\n    -moz-user-select: none; /* Firefox all */\n    -ms-user-select: none; /* IE 10+ */\n    -webkit-tap-highlight-color: transparent; /*Nécessaire sur ipad pour ne pas avoir de rectanle gris sélectionné lors des touch events */\n}", ""]);

// exports
